/**
 * L.Control.GeoSearch - search for an address and zoom to it's location
 * L.GeoSearch.Provider.Eme uses EME geocoding service
 * https://github.com/smeijer/leaflet.control.geosearch
 */

L.GeoSearch.Provider.Eme = L.Class.extend({
    options: {

    },

    initialize: function (options) {
        options = L.Util.setOptions(this, options);
    },

    GetServiceUrl: function (qry) {
        var parameters = {
            location: qry
        };

        return '/api/geo/location'
            + L.Util.getParamString(parameters);
    },

    ParseJSON: function (data) {
        if (!data || !data.success)
            return [];

        var locations = data.data.locations.matches,
            results = [];
        
        for (var i = 0; i < locations.length; i++)
            results.push(new L.GeoSearch.Result(
                locations[i].latLng.lng,
                locations[i].latLng.lat,
                locations[i].displayName
            ));

        return results;
    }
});
define("leaflet-geosearch-eme", ["leaflet-geosearch"], function(){});

